import React, { useState, useEffect } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'react-toastify';
import { FiHome, FiUsers, FiMessageCircle, FiDatabase, FiCalendar, FiPieChart, FiZap, FiTrendingUp, FiShield, FiSettings, FiLogOut } from 'react-icons/fi';
import NotificationBell from '../NotificationBell';
import api from '../../utils/api';

const navItems = [
  { path: '/admin/dashboard', label: 'Overview', icon: <FiHome /> },
  { path: '/admin/users', label: 'Team', icon: <FiUsers /> },
  { path: '/admin/campaigns', label: 'Broadcasts', icon: <FiMessageCircle /> },
  { path: '/admin/master-data', label: 'Data Hub', icon: <FiDatabase /> },
  { path: '/admin/schedules', label: 'Scheduler', icon: <FiCalendar /> },
  { path: '/admin/reports', label: 'Analytics', icon: <FiPieChart /> },
  { path: '/admin/insights', label: 'Insights', icon: <FiZap /> },
  { path: '/admin/performance', label: 'Performance', icon: <FiTrendingUp /> },
  { path: '/admin/audit-logs', label: 'Audit Logs', icon: <FiShield /> },
  { path: '/admin/settings', label: 'Settings', icon: <FiSettings /> },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [branding, setBranding] = useState(null);

  useEffect(() => {
    api.get('/auth/branding').then(({ data }) => setBranding(data)).catch(() => {});
  }, []);

  const handleLogout = async () => {
    await logout();
    toast.success('Logged out successfully');
    navigate('/login');
  };

  return (
    <div className="app-layout">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <img src={branding?.logoUrl || '/Affixcenter_OG_Fulllogo.png'} alt="Logo" className="sidebar-logo-img" style={{ width: 38, height: 38, borderRadius: 8, objectFit: 'contain', background: 'white' }} />
          <div className="sidebar-logo-text">
            <h1>{branding?.appName || 'Affix Digital Setu'}</h1>
            <span>{branding?.panelLabels?.admin || 'Admin Panel'}</span>
          </div>
        </div>

        <nav className="sidebar-nav">
          <div className="sidebar-section">
            <div className="sidebar-section-title">Navigation</div>
            {navItems.map(item => (
              <NavLink key={item.path} to={item.path} data-tooltip={item.label}
                className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
                {item.icon}
                <span className="link-label">{item.label}</span>
              </NavLink>
            ))}
          </div>
        </nav>

        <div className="sidebar-footer">
          <button onClick={handleLogout} className="sidebar-link" data-tooltip="Logout" style={{ width: '100%', border: 'none', background: 'none', cursor: 'pointer', fontFamily: 'inherit' }}>
            <FiLogOut />
            <span className="link-label">Logout</span>
          </button>
        </div>
      </aside>

      <header className="header">
        <h2 className="header-title">Admin Dashboard</h2>
        <div className="header-actions">
          <NotificationBell role="admin" />
          <div className="header-user">
            <div className="header-avatar">{user?.username?.[0]?.toUpperCase()}</div>
            <div className="header-user-info">
              <span>{user?.username}</span>
              <small>{user?.role}</small>
            </div>
          </div>
        </div>
      </header>

      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
